import { openDB, type DBSchema, type IDBPDatabase } from 'idb';
import type { ContentRow, LogRow, MediaRow } from '../types/content';
import type { StreamConfig } from '../types/stream';

export interface KvValues {
  device_token: string;
  device_uuid: string;
  device_id: number;
  sequence: number;
  config: StreamConfig;
  last_log_ts: number;
  // Local display rotation chosen at pairing (TVs can't be physically rotated).
  display_rotation: number; // 0 / 90 / 180 / 270
}

interface VizzlyDB extends DBSchema {
  kv: {
    key: string;
    value: unknown;
  };
  content: {
    key: string; // uuid
    value: ContentRow;
    indexes: { 'by-sequence': number };
  };
  media: {
    key: string; // file name
    value: MediaRow;
  };
  logs: {
    key: number;
    value: LogRow;
  };
}

const DB_NAME = 'vizzly-player';
const DB_VERSION = 1;

let dbPromise: Promise<IDBPDatabase<VizzlyDB>> | null = null;

export function getDB(): Promise<IDBPDatabase<VizzlyDB>> {
  if (!dbPromise) {
    dbPromise = openDB<VizzlyDB>(DB_NAME, DB_VERSION, {
      upgrade(db) {
        if (!db.objectStoreNames.contains('kv')) {
          db.createObjectStore('kv');
        }
        if (!db.objectStoreNames.contains('content')) {
          const content = db.createObjectStore('content', { keyPath: 'uuid' });
          content.createIndex('by-sequence', 'sequence');
        }
        if (!db.objectStoreNames.contains('media')) {
          db.createObjectStore('media', { keyPath: 'name' });
        }
        if (!db.objectStoreNames.contains('logs')) {
          db.createObjectStore('logs', { keyPath: 'id', autoIncrement: true });
        }
      },
    });
  }
  return dbPromise;
}
